/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AnyNonRedactedAutoTestStepAsJSON } from './AnyNonRedactedAutoTestStepAsJSON';
import { RunProgramExtra } from './RunProgramExtra';
const RunProgramAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(RunProgramExtra, AnyNonRedactedAutoTestStepAsJSON);
export class RunProgramAsJSON extends AnyNonRedactedAutoTestStepAsJSON {
    static decode(input) {
        return RunProgramAsJSONParser.decode(input).map(res => new RunProgramAsJSON(res));
    }
    static unsafeDecode(input) {
        return RunProgramAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RunProgramAsJSONParser.encode(data);
    }
    static schema() {
        return RunProgramAsJSONParser.schema();
    }
}
